<div class="wcg-popup">
  <div *ngIf="showImpersonation && loginService.user?.isGlobalAdmin" class="wcg-impersonate-bar">
    <svg xmlns="http://www.w3.org/2000/svg" style="display:none">
      <symbol id="icon-impersonate-popup" viewBox="0 0 16 16" fill="none">
        <circle cx="6.5" cy="5" r="3" stroke="currentColor" stroke-width="1.4"/>
        <path d="M1 14c0-3 2.5-5.5 5.5-5.5S12 11 12 14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
        <path d="M13 8l2 2-2 2M15 10h-4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </symbol>
    </svg>
    <button class="um-btn" [disabled]="!selectedRow" (click)="impersonateUser()">
      <svg class="btn-icon" aria-hidden="true"><use href="#icon-impersonate-popup"/></svg>
      Impersonate User
    </button>
  </div>
  <div *ngIf="gridKey === 'fracxClientMgmt' && loginService.user?.isGlobalAdmin" class="wcg-impersonate-bar">
    <button class="um-btn" [disabled]="!selectedRow" (click)="selectRegions()">
      FracX Regions
    </button>
  </div>
  <div *ngIf="gridKey === 'fracxUserMgmt' && (loginService.user?.isGlobalAdmin || loginService.user?.isCompanyAdmin)" class="wcg-impersonate-bar">
    <button class="um-btn" [disabled]="!selectedRow" (click)="selectUserRegions()">
      FracX Regions
    </button>
  </div>
  <p *ngIf="gridKey === 'taskEventHistory'" class="wcg__muted wcg-hint">Right-click a row to view its payload.</p>
  <wc-grid [gridKey]="gridKey"
           [showQuickSearch]="showQuickSearch"
           [searchPlaceholder]="searchPlaceholder"
           [context]="context"
           [contextMenuItems]="contextMenuItems"
           (contextMenuAction)="onGridAction($event)"
           (selectedRowChange)="onRowSelected($event)" />
</div>
